module.exports = "/assets/logo_sg_characteranimator-845ea1b7d7521c0d49a45e7c38871ae4.png";